<template>
  <v-container
    fluid
    class="fill-height pa-0"
  >
    <v-row
      align="center"
      justify="center"
      class="ma-0 fill-height"
    >
      <div
        :class="['card', {
          'card-focus': cvvFocus
        }]"
      >
        <div class="cc-front cc-part mx-auto">
          <img class="cc-front-square cc-square" src="https://image.ibb.co/cZeFjx/little_square.png" alt="cc">
          <div class="cc-front-logo cc-logo ">
            <div :class="cardBrandLogo"></div>
          </div>
          <p class="card-number">{{number}}</p>
          <div class="cc-space-75">
            <span class="cc-label">Card holder</span>
            <p class="cc-info"/>
          </div>
          <div class="cc-space-25">
            <span class="cc-label">Expires</span>
            <p class="cc-info">{{month}}/{{year}}</p>
          </div>
        </div>
        <div class="cc-back cc-part">
          <div class="cc-black-line"></div>
          <div class="cc-back-content">
            <div class="cc-secret">
              <p class="cc-secret-last">{{cvv}}</p>
            </div>
            <img class="cc-back-square cc-square" src="https://image.ibb.co/cZeFjx/little_square.png"
                 alt="cc">
            <div class="cc-back-logo cc-logo ">
              <div :class="cardBrandLogo"></div>
            </div>
          </div>
        </div>
      </div>
    </v-row>
  </v-container>
</template>

<script>
  import {guessCreditCardBrand, unmask} from "../../../helpers/utils"
  import {CREDIT_CARD_LOGO} from "../../../helpers/payment/constants"

  export default {
    name: "CreditCardHelper",
    props: {
      cvvFocus: {
        type: Boolean,
        default: false
      },
      number: String,
      cvv: String,
      month: String,
      year: String
    },
    computed: {
      numberMasks() {
        return ["#### #### #### ####", "#### ###### #####"]
      },
      creditCardBrand() {
        if (!this.number) return null
        if (unmask(this.number, this.numberMasks).length === 0) return null
        return guessCreditCardBrand(unmask(this.number, this.numberMasks))
      },
      cardBrandLogo() {
        return CREDIT_CARD_LOGO[this.creditCardBrand] || ""
      }
    }
  }
</script>

<style scoped lang="scss">
  .card-logo {
    display: inline-block;
    width: 130px;
    height: 100px;
    background-size: 160px 100px;

    &.mini {
      width: 24px !important;
      height: 24px !important;
      background-size: 24px 24px !important;
      font-size: 24px !important;
    }

    &.small {
      width: 53.33333333px;
      height: 33.33333333px;
      background-size: 53.33333333px 33.33333333px;
    }

    &.large {
      width: 240px;
      height: 150px;
      background-size: 240px 150px;
    }

    &.visa {
      background-image: url('../../../assets/payment/card-logo-visa.svg');
    }

    &.mastercard {
      background-image: url('../../../assets/payment/card-logo-mastercard.svg');
    }

    &.amex {
      background-image: url('../../../assets/payment/card-logo-amex.svg');
    }

    &.elo {
      background-image: url('../../../assets/payment/elo-logo.svg');
    }

    &.unknown {
      background-image: url('../../../assets/payment/card-logo-unknown.svg');
    }
  }

  .card {
    width: 320px;
    height: 190px;
    -webkit-perspective: 600px;
    -moz-perspective: 600px;
    perspective: 600px;
    text-align: left;
    margin: 0 auto;

    &.card-focus {
      .cc-front {
        -webkit-transform: rotateY(180deg);
        -moz-transform: rotateY(180deg);
      }

      .cc-back {
        -webkit-transform: rotateY(0deg);
        -moz-transform: rotateY(0deg);
      }
    }

    &:hover {
      .cc-front {
        -webkit-transform: rotateY(180deg);
        -moz-transform: rotateY(180deg);
      }

      .cc-back {
        -webkit-transform: rotateY(0deg);
        -moz-transform: rotateY(0deg);
      }
    }

    .cc-part {
      box-shadow: 1px 1px #aaa3a3;
      top: 0;
      position: absolute;
      z-index: 1000;
      left: 0;
      display: inline-block;
      width: 300px;
      height: 185px;
      background-image: url('https://image.ibb.co/bVnMrc/g3095.png'), linear-gradient(to right bottom, #005378, #005C85, #005C85, #005C85, #00415E); /*linear-gradient(to right bottom, #fd8369, #fc7870, #f96e78, #f56581, #ee5d8a)*/
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
      border-radius: 8px;
      -webkit-transition: all .5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
      -moz-transition: all .5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
      -o-transition: all .5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
      transition: all .5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
      -webkit-transform-style: preserve-3d;
      -webkit-backface-visibility: hidden;
      -moz-backface-visibility: hidden;
    }

    .cc-front {
      padding: 18px;
      -webkit-transform: rotateY(0);
      -moz-transform: rotateY(0);
    }

    .cc-back {
      padding: 18px 0;
      -webkit-transform: rotateY(-180deg);
      -moz-transform: rotateY(-180deg);
    }

    .cc-black-line {
      margin-top: 5px;
      height: 38px;
      background-color: #303030;
    }

    .cc-logo {
      height: 16px;
    }

    .cc-front-logo {
      position: absolute;
      top: 18px;
      right: 18px;
    }

    .cc-square {
      border-radius: 5px;
      height: 30px;
      text-align: left;
    }

    .card-number {
      display: block;
      width: 100%;
      word-spacing: 4px;
      font-size: 20px;
      letter-spacing: 2px;
      color: #fff;
      text-align: center;
      margin-bottom: 20px;
      margin-top: 25px;
    }

    .cc-space-75 {
      width: 75%;
      float: left;
      margin-top: 10px;
    }

    .cc-space-25 {
      width: 25%;
      float: left;
      text-align: right;
      margin-top: 10px;
    }

    .cc-label {
      font-size: 10px;
      text-transform: uppercase;
      color: rgba(255, 255, 255, 0.8);
      letter-spacing: 1px;
    }

    .cc-info {
      margin-bottom: 0;
      margin-top: 5px;
      font-size: 16px;
      line-height: 18px;
      color: #fff;
      letter-spacing: 1px;
      text-transform: uppercase;
    }

    .cc-back-content {
      padding: 15px 15px 0;
    }

    .cc-secret-last {
      color: #303030;
      text-align: right;
      margin: 0;
      font-size: 14px;
    }

    .cc-secret {
      padding: 5px 12px;
      background-color: #fff;
      position: relative;
    }

    .cc-secret:before {
      content: '';
      position: absolute;
      top: -3px;
      left: -3px;
      height: calc(100% + 6px);
      width: calc(100% - 42px);
      border-radius: 4px;
      background: repeating-linear-gradient(45deg, #ededed, #ededed 5px, #f9f9f9 5px, #f9f9f9 10px);
    }

    .cc-back-logo {
      position: absolute;
      bottom: 30px;
      right: 15px;
    }

    .cc-back-square {
      position: absolute;
      bottom: 15px;
      left: 15px;
    }
  }
</style>
